import paths from 'routes/paths';
import { clearActingProducer, setActingProducerId } from 'helpers/actingProducer';
import { firstAllowedPanelPath } from 'helpers/panelPermissions';
import { actorHasOwnPanel } from 'helpers/dashboardAccess';

/**
 * Entra no painel de um produtor como membro da equipe. A página recarrega de
 * propósito: o painel precisa subir já falando em nome do produtor, e não
 * misturar o usuário carregado antes com o que a API devolve agora.
 *
 * @param {{ producer_id: number|string, permissions: string[] }} access
 */
export function enterProducerPanel(access) {
    setActingProducerId(access.producer_id);

    window.location.assign(firstAllowedPanelPath(access.permissions) || paths.dashboard.support);
}

export function leaveProducerPanel() {
    clearActingProducer();

    window.location.assign(paths.events.home);
}

/**
 * Volta para o painel do próprio produtor, saindo do painel de outro. A página
 * recarrega pelo mesmo motivo de `enterProducerPanel`.
 */
export function openOwnPanel() {
    clearActingProducer();

    window.location.assign(paths.dashboard.statistics);
}

/**
 * Sai do painel de outro produtor: quem tem painel próprio volta para ele,
 * quem não tem volta para o site.
 */
export function leaveToOwnContext(user) {
    if (actorHasOwnPanel(user)) {
        openOwnPanel();
        return;
    }

    leaveProducerPanel();
}
